import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    SAVE_COUPON,
    saveCouponFail,
    saveCouponSuccess
} from '../action/saveCouponAction'

// api 
import saveCouponApi from '../api/saveCouponApi'

export function* saveCouponSaga(action) {
    try {
        const response = yield call(() => saveCouponApi(action.params))
        if (response.data.status === 1) {
            yield put(saveCouponSuccess(response, action))
        } else {
            yield put(saveCouponFail(response, action))
        }
    }
    catch (e) {
        yield put(saveCouponFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(SAVE_COUPON, saveCouponSaga)
}